import { css } from '~/styled-system/css'

export const BackToYahooTop = import.meta.env.VITE_MODE === 'ppg' ? PpgBackToYahooTop : Empty

function Empty() {
  return null
}

export function PpgBackToYahooTop({ isFromYahooTop }: { isFromYahooTop: boolean }) {
  if (!isFromYahooTop) {
    return null
  }
  return (
    <div
      className={css({
        py: '1',
        _sd: { bg: 'gray.100', px: '1' },
        maxWidth: 'content.base',
        mx: 'auto',
      })}
    >
      <a
        className={css({
          fontSize: 'sm',
          color: 'gray.600',
          _hover: { opacity: '75' },
        })}
        href="https://www.yahoo.co.jp/"
        target="_blank"
      >
        « Yahoo! JAPANへ戻る
      </a>
    </div>
  )
}
